import StringColumn from "@isceco/widget-library2/basic-elements/List/column/StringColumn.js";
import AuthorizationFilter from '../Authorization/AuthorizationFilter'

export default class GPColumns {

  static getColumns() {
    const roles = new AuthorizationFilter().roles
    if (roles.BWL || roles.OSTRAL) {
      return [
        GPColumns.NAME_COLUMN(),
        GPColumns.ORT_COLUMN(),
        GPColumns.KANTON_COLUMN(),
        GPColumns.VERANTWORTLICHE_COLUMN(),
        GPColumns.VNB_COLUMN()
      ]
    } else {
      return [
        GPColumns.NAME_COLUMN(),
        GPColumns.ORT_COLUMN(),
        GPColumns.KANTON_COLUMN(),
        GPColumns.VERANTWORTLICHE_COLUMN()
      ]
    }
  }

  static NAME_COLUMN() {
    return new StringColumn({
      key: 'name',
      text: 'gp.table.header.name',
      sortable: true
    })
  }

  static ORT_COLUMN() {
    return new StringColumn({
      key: 'adresse',
      text: 'gp.table.header.adresse',
      sortable: true
    })
  }

  static KANTON_COLUMN() {
    return new StringColumn({
      key: 'kanton',
      text: 'gp.table.header.kanton',
      weight: 0.5,
      sortable: true
    })
  }

  static VERANTWORTLICHE_COLUMN() {
    return new StringColumn({
      key: 'verantwortlichePerson',
      text: 'gp.table.header.verantwortlichePerson',
      sortable: true
    })
  }

  static VNB_COLUMN() {
    return new StringColumn({
      key: 'vnb',
      text: 'gp.table.header.vnb',
      sortable: true
    })
  }

}
